const dns_template = {
	dialog_add_template: {
		description: "Add a new DNS template here. After adding it, you can populate the template.",
		input_description: {
			label: "Description DNS-template",
			placeholder: "Optionally give the template a description",
		},
		input_name: {
			label: "Name DNS-template",
			placeholder: "e.g. 'template-webserver'",
		},
		messages: {
			success: "DNS template <strong>{{name}}</strong> has been created successfully!",
		},
		title: "Add DNS template",
	},
	dialog_delete_template: {
		description: "Are you sure you want to delete template <strong>{{name}}</strong>?",
		messages: {
			success: "DNS template <strong>{{name}}</strong> has been successfully deleted!",
		},
		title: "Delete DNS template",
	},

	/* -------------------------------------------------------------------------- */
	/*                                  DNS TABLE                                 */
	/* -------------------------------------------------------------------------- */
	dns_table: {},

	/* -------------------------------------------------------------------------- */
	/*                        DNS TEMPLATE MANAGEMENT PAGE                        */
	/* -------------------------------------------------------------------------- */
	management: {
		buttons: {
			add_record: "Add record",
			choose_template: "Choose Template records",
			remove_default: "Template is set as default",
			retrieve_dns: "Retrieve DNS records",
			set_as_default: "Set as default",
		},
		form: {
			description: "Description",
			name: "Name",
		},
		information:
			"DNS Templates allow you to easily create DNS records for your domains. You can use these templates when creating a new domain, or to manage DNS records for existing domains.",
		messages: {
			set_as_default_selected: "DNS records activated as default",
			set_as_default_unselected: "DNS records deactivated as default",
			success: "DNS template <strong>{{name}}</strong> has been changed successfully!",
		},
		sure_to_leave: "Are you sure you want to leave the page?\nUnsaved changes will be lost.",
		tooltips: {
			choose_template:
				"This button allows you to select DNS records from one of your other DNS templates to add to the current DNS records list.",
			retrieve_dns:
				"This button allows you to retrieve DNS records from an existing domain name, and choose which DNS records to import to use in the current DNS records list.",
			set_as_default:
				"This button allows you to set the current DNS template as the default. This means that this template is automatically selected during the creation of a new domain, and thus is useful if you often choose this template during domain creation.",
		},
	},
	/* -------------------------------------------------------------------------- */
	/*                                OVERVIEW PAGE                               */
	/* -------------------------------------------------------------------------- */
	overview: {
		table: {
			default: "Default",
			description: "Description",
			label: "Label",
		},
		title: "DNS templates",
	},
};

export default dns_template;
